export class Path {
  public static readonly LOGIN = {
    GET_USER_DETAILS: "con-login/get"
  };

  public static readonly WEB_USER = {
    GET_LIST: "con-web-user/list",
    GET_USER: "con-web-user/get",
    GET_ROLES: "con-web-role/list",
    UPDATE_USER: "con-web-user/update",
    ADD_USER: "con-web-user/insert",
    DELETE_USER: "con-web-user/delete",
    DOWNLOAD_LIST: "con-web-user-download/task-runner",
  }

  public static readonly BOOKING = {
    GET_LIST: "con-booking/list",
    GET_BOOKING: "con-booking/get",
    UPDATE_BOOKING: "con-booking/update",
    GET_FILTER_LIST: "con-bookingstatus/list",
  }

  public static readonly AIRCRAFT = {
    GET_LIST: "con-shipment-mode/list",
    GET_AIRCRAFT: "con-shipment-mode/get",
    UPDATE_AIRCRAFT: "con-shipment-mode/update",
    ADD_AIRCRAFT: "con-shipment-mode/insert",
    DOWNLOAD_LIST: "con-ship-mode-dn/task-runner"
  }

  public static readonly VESSEL = {
    GET_LIST: "con-shipment-mode/list",
    GET_VESSEL: "con-shipment-mode/get",
    UPDATE_VESSEL: "con-shipment-mode/update",
    ADD_VESSEL: "con-shipment-mode/insert"
  }

  public static readonly SECURITY_MATRIX = {
    GET_LIST: "con-web-role/list",
    GET_ROLE: "con-web-role-matrix/list",
    UPDATE_ROLE: "con-web-role-matrix/update",
    GET_MODULE_GROUP: "con-web-module-group/list"
  }

  public static readonly LOAD_PLAN = {
    GET_LIST: "con-loadplan/list-header",
    GET_LOAD_PLAN: "con-loadplan/get-detail",
    GET_LOAD_PLAN_BOOKING_LIST: "con-loadplan/get-booking",
    UPSERT_LOAD_PLAN: "con-loadplan/upsert",
  }

  public static readonly GENERIC = {
    GET_PORTS_LIST:"con-ports/list",
    GET_CONTAINER_SIZES:"con-containersize/list",
    GET_DECONSOLIDATOR_LIST: "con-deconsolidator/list",
    GET_SHIPMENT_MODE_LIST: "con-shipment-mode-ddl/list",
    GET_CONTAINER_NUMBER_LIST: "con-containernums/list",
    GET_ROLE_LIST: "con-web-role/list"
  }

  public static readonly PRIVACY_POLICY = {
    GET_PRIVACY_POLICY: "con-data-privacy/get"
  }

  
}